import Container from 'components/container';
import HomeAnchorImage from 'components/header/HomeAnchorImage';
import Anchor from 'components/typography/anchor';
import PropTypes from 'prop-types';

import { Nav } from './Nav';

const Header = ({ children = null, siteTitle }) => {
  return (
    <header className="fixed z-10 min-h-16 w-full border-b border-black/10 bg-white/70 text-center backdrop-blur-xl dark:border-white/10 dark:bg-indigo-950/50 print:hidden">
      <div className="relative">
        <Anchor
          label="Resistbot Home"
          href="/"
          className="absolute top-4 left-4 h-16"
        >
          <HomeAnchorImage siteTitle={siteTitle} />
        </Anchor>
        <Nav />
        <Container>{children}</Container>
      </div>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Header;
